import api from "@/api/api";

export default {
  index() {
    return api.get("main/notification-settings");
  },
  update(id, payload) {
    return api.put(`main/notification-settings/${id}`, payload);
  },
  postAnnouncement(payload) {
    return api.post("main/announcements", payload);
  },
  audienceGroups() {
    return api.get("main/announcement-audience-groups");
  },
  createAudienceGroup(payload) {
    return api.post("main/announcement-audience-groups", payload);
  },
  updateAudienceGroup(id, payload) {
    return api.put(`main/announcement-audience-groups/${id}`, payload);
  },
  deleteAudienceGroup(id) {
    return api.delete(`main/announcement-audience-groups/${id}`);
  },
};
